import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CallbackComponent } from './callback/callback.component';
import { AuthGuard } from './services/guards/login.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full',
  },
  { path: 'callback', component: CallbackComponent },
  {
    path: 'home',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./main/main-routing.module').then((m) => m.MainRoutingModule),
  },
  /*   { path: 'auth', loadChildren: () => import('./auth/auth-routing.module').then(m => m.AuthRoutingModule) }, */
  {
    path: 'almacen-equipos',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./almacen-equipos/almacen-equipos-routing.module').then(
        (m) => m.AlmacenEquiposRoutingModule
      ),
  },
  {
    path: 'almacen-menajeria',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./almacen-menajeria/almacen-menajeria-routing.module').then(
        (m) => m.AlmacenMenajeriaRoutingModule
      ),
  },
  // {
  //   path: 'home',
  //   canLoad: [LoginGuard],
  //   loadChildren: () =>
  //     import('./main/main-routing.module').then(m => m.MainRoutingModule)
  // },
  // {
  //   path: 'auth',
  //   loadChildren: () =>
  //     import('./auth/auth-routing.module').then(m => m.AuthRoutingModule)
  // },
  // {
  //   path: 'almacen-insumos',
  //   canLoad: [LoginGuard],
  //   loadChildren: () =>
  //     import('./file/almacen-insumos-routing.module').then(m => m.AlmacenInsumosRoutingModule)
  // },
  // {
  //   path: 'almacen-aventura',
  //   canLoad: [LoginGuard],
  //   loadChildren: () =>
  //     import('./file/almacen-aventura-routing.module').then(m => m.AlmacenAventuraRoutingModule)
  // },
  // {
  //   path: 'almacen-menajeria',
  //   canLoad: [LoginGuard],
  //   loadChildren: () =>
  //     import('./file/almacen-menajeria-routing.module').then(m => m.AlmacenMenajeriaRoutingModule)
  // },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  /*   providers: [ AuthGuard ] */
})
export class AppRoutingModule {}
